export default __webpack_public_path__ + "static/icon-spacing-dark-cac95b91bbae516fef820497515f8b2669fce1341ac4c5a90495d8aa3633f616.png";